const n = {
  name: "RiskDanger",
  dimensions: { width: 32, height: 41 },
  content: `
    <g fill="currentColor" stroke="none">
       <path d="M3.95254 22.001H15.1396L13.4001 35.8467L28.0963 18.8319C28.3762 18.512 28.1463 18.0022 27.7164 18.0022H13.87L15.5295 4.73633L3.54265 21.2112C3.30271 21.5411 3.54265 22.001 3.95254 22.001ZM11.0107 38.8757L12.8702 24.0003H1.0033C0.183518 24.0003 -0.28636 23.0706 0.193515 22.4108L16.1894 0.417679C16.7992 -0.42206 18.1189 0.107775 17.9889 1.12746L16.1294 16.0028H30.9955C31.8553 16.0028 32.3152 17.0125 31.7553 17.6523L12.7603 39.6455C12.1104 40.4052 10.8907 39.8554 11.0107 38.8757Z"/>
    </g>
  `
};
export {
  n as RiskDanger
};
